import { render } from "./ThanksPointSearchMore.vue?vue&type=template&id=616f89ea&scoped=true&ts=true"
import script from "./ThanksPointSearchMore.vue?vue&type=script&lang=ts"
export * from "./ThanksPointSearchMore.vue?vue&type=script&lang=ts"

import "./ThanksPointSearchMore.vue?vue&type=style&index=0&id=616f89ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616f89ea"]])

export default __exports__